import {Table, Typography} from "antd";
import {t} from "i18next";
import Helper from "../../../core/Helper";

export default function PaymentSummary({data})
{
    return (
        <>
            {
                data?.appointmentSummaries?.map(summaryRow => (
                    <div style={{marginBottom: 32}}>
                        <Table
                            size={'small'}
                            dataSource={summaryRow?.paymentMethodSummaries}
                            rowKey={'name'}
                            pagination={false}
                            columns={[
                                {dataIndex: 'name', key: 'name', title: t('Payment Method') + ` (${summaryRow?.currency})`,},
                                {dataIndex: 'total', key: 'total', title: t('Total') + ` (${summaryRow?.currency})`, render: (text, row) => Helper.Currency.format(text, {currency: summaryRow?.currency})},
                            ]}
                        />
                    </div>
                ))
            }
        </>
    )
}